<template>
<div>
  <!-- <v-row justify="center" class="pt-8 mx-xs-auto mt-lg-8">
  <div style="font-weight:bold; font-size:1.2rem; color:#888888;">About</div>
  </v-row> -->
  <serviceSlide></serviceSlide>
  <v-row justify="center" class="pt-3 mx-xs-auto mt-lg-8">
    <div class="pa-7 py-3 mx-lg-auto">
    徳島でソフトウェア開発を行っている会社です。私達は研究で得た知識やお客様からのフィードバックをもとに製品開発を行っています。<br/>
    試用、製品についてのご相談等お気軽にお問い合わせください。
    </div>
  </v-row>
  <div class="pa-7" id="" style="max-width:1200px; margin:0 auto;">
    <!--内容-->
    <v-row>
      <v-col cols="12" xs="8" md="6" lg="6" xl="6">
        <router-link :to="{ path: '/Service' }" append>
          <figure class="top-box-menu-area">
            <v-img src="../assets/Home/serviceSlide/conference.jpg" gradient="to top right, rgba(166,173,173,.1), rgba(130,135,135,.7)" height="200px" class="service-box-img">
              <div class="v-img-text"><br/>
                <div class="top-box-menu">
                  <!-- Serviceページへのリンク -->
                  <router-link :to="{ path: '/Service' }" @click.stop>
                    <v-icon color="white">mdi-school</v-icon>サービス<br/>
                  </router-link>
                  <div class="figcaption-text">
                    <a href="https://hp.konniesystem.co.jp/" target="_blank" rel="noopener noreferrer" @click.stop>
                      コニーシステム ホームページラボ
                    </a>
                  </div>
                  <span class="figcaption-text inline-span">
                    <!-- 外部リンクは @click.stop で router-link に影響しないように -->
                    <a href="https://konniesystem.co.jp/hp_maintenance/" target="_blank" rel="noopener noreferrer" @click.stop>
                      ホームページ運用保守
                    </a><br/>
                    <!-- 内部リンクには router-link を使う -->
                    <router-link :to="{ path: '/Service/Maintenance' }">システム運用保守</router-link><br/>
                    <router-link :to="{ path: '/Service/supportConference' }">学会サポート</router-link><br/>
                  </span>
                  <span class="figcaption-text inline-span">
                    <router-link :to="{ path: '/Products/reserveMedical'}" append>ワクチン予約システム</router-link><br/>
                    <router-link :to="{ path: '/Service/supportOSS' }">OSS製品のサポート</router-link><br/>
                    <router-link :to="{ path: '/Service/academicSite' }">学術機関向けサイト作成</router-link><br/>
                  </span>
                </div>
              </div>
            </v-img>

<!--            <figcaption>-->
<!--              <div class="v-img-text"><br/>-->
<!--                <div class="top-box-menu">-->
<!--                  &lt;!&ndash; Serviceページへのリンク &ndash;&gt;-->
<!--                  <router-link :to="{ path: '/Service' }" @click.stop>-->
<!--                    <v-icon color="white">mdi-school</v-icon>サービス<br/>-->
<!--                  </router-link>-->
<!--                  <span class="figcaption-text">-->
<!--                    &lt;!&ndash; 外部リンクは @click.stop で router-link に影響しないように &ndash;&gt;-->
<!--                    <a href="https://konniesystem.co.jp/hp_maintenance/" target="_blank" rel="noopener noreferrer" @click.stop>-->
<!--                      ホームページ運用保守-->
<!--                    </a><br/>-->
<!--                    &lt;!&ndash; 内部リンクには router-link を使う &ndash;&gt;-->
<!--                    <router-link :to="{ path: '/Service/Maintenance' }">システム運用保守</router-link><br/>-->
<!--                    <router-link :to="{ path: '/Service/supportConference' }">学会サポート</router-link><br/>-->
<!--                    <router-link :to="{ path: '/Service/academicSite' }">学術機関向けサイト作成</router-link><br/>-->
<!--                    <router-link :to="{ path: '/Service/supportOSS' }">OSS製品のサポート</router-link><br/>-->
<!--                  </span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </figcaption>-->
          </figure>
        </router-link>
      </v-col>

      <v-col  cols="12" xs="8" md="6" lg="6" xl="6">
        <router-link :to="{ path: '/Service/Investigation'}" append @click.stop>
          <figure class="top-box-menu-area">
            <v-img src='../assets/investigation.jpg' gradient="to top right, rgba(166,173,173,.1), rgba(130,135,135,.7)" height='200px'>
              <div class="v-img-text"><br/>
                <!-- <div class="top-box-menu"><v-icon color=white>mdi-lightbulb</v-icon>研究開発</div> -->
                <div class="top-box-menu">
                  <router-link :to="{ path: '/Service/Investigation'}" append @click.stop>
                    <v-icon color=white>mdi-lightbulb</v-icon>研究開発<br/>
                  </router-link>
                  <div class="figcaption-text">
                    <a href="https://ai.konniesystem.co.jp/" target="_blank" rel="noopener noreferrer" @click.stop>
                      コニーシステム AIラボ
                    </a>
                  </div>
                  <span class="figcaption-text">
                    研究開発から得られた成果を<br>ソフトウェア開発にフィードバックしています。<br/>
                  </span>
                </div>
              </div>
<!--              <figcaption>-->
<!--                <div class="v-img-text"><br/>-->
<!--                  <div class="top-box-menu">-->
<!--                    <router-link :to="{ path: '/Service/Investigation'}" append @click.stop>-->
<!--                      <v-icon color=white>mdi-lightbulb</v-icon>研究開発<br/>-->
<!--                    </router-link>-->
<!--                    <span class="figcaption-text">-->
<!--                      研究開発から得られた成果を<br>ソフトウェア開発にフィードバックしています。-->
<!--                    </span>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </figcaption>-->
            </v-img>
          </figure>
        </router-link>
      </v-col>
    </v-row>

    <v-row style=''>
      <v-col cols="12" xs="8"  md="6" lg="6" xl="6">
        <router-link :to="{ path: '/Service/Commissioned'}" @click.stop>
          <figure class="top-box-menu-area">
            <v-img src='../assets/Products/search2.jpg' gradient="to top right, rgba(166,173,173,.1), rgba(130,135,135,.7)" height='200px'>
              <div class="v-img-text"><br/>
                <div class="top-box-menu">
                  <router-link :to="{ path: '/Service/Commissioned'}" @click.stop>
                    <v-icon color=white>mdi-charity</v-icon>
                    受託開発
                  </router-link><br/>
                  <span class="figcaption-text">
                    Python、Java、C#、C++、php等によるシステムの受託開発いたします。
                  </span>
                </div>
              </div>
<!--              <figcaption>-->
<!--                <div class="v-img-text"><br/>-->
<!--                  <div class="top-box-menu">-->
<!--                    <router-link :to="{ path: '/Service/Commissioned'}" @click.stop>-->
<!--                      <v-icon color=white>mdi-charity</v-icon>-->
<!--                      受託開発-->
<!--                    </router-link><br/>-->
<!--                    <span class="figcaption-text">-->
<!--                      Java、C#、C++、php、ruby等によるシステムの受託開発いたします。-->
<!--                    </span>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </figcaption>-->
            </v-img>
          </figure>
        </router-link>
      </v-col>

      <v-col cols="12" xs="8" md="6" lg="6" xl="6">
        <router-link :to="{ path: '/Products'}" append @click.stop>
          <figure class="top-box-menu-area">
            <v-img src='../assets/Home/serviceSlide/reserveDental.jpg' gradient="to top right, rgba(166,173,173,.1), rgba(130,135,135,.7)" height='200px' name="seihinannai">
              <div class="v-img-text"><br/>
                <div class="top-box-menu">
                  <router-link :to="{ path: '/Products'}" append @click.stop>
                    <v-icon color=white>mdi-file-document-outline</v-icon>製品案内
                  </router-link><br/>
                  <span class="figcaption-text">
                  <router-link :to="{ path: '/Products/Search'}" append>検索システム</router-link><br/>
                  <router-link :to="{ path: '/Products/reserveMedical'}" append>診療予約システム</router-link><br/>
                  <router-link :to="{ path: '/Products/Elearning'}" append>e-Learningシステム</router-link><br/>
                  <router-link :to="{ path: '/Products'}" append>会議システム</router-link></span>
                </div>
              </div>
            </v-img>
<!--            <figcaption>-->
<!--              <div class="v-img-text"><br/>-->
<!--                <div class="top-box-menu">-->
<!--                  <router-link :to="{ path: '/Products'}" append @click.stop>-->
<!--                    <v-icon color=white>mdi-file-document-outline</v-icon>製品案内-->
<!--                  </router-link><br/>-->
<!--                  <span class="figcaption-text">-->
<!--                    <router-link :to="{ path: '/Products/Search'}" append>検索システム</router-link><br/>-->
<!--                    <router-link :to="{ path: '/Products/Elearning'}" append>e-Learningシステム</router-link><br/>-->
<!--                    <router-link :to="{ path: '/Products'}" append>予約システム</router-link><br/>-->
<!--                    <router-link :to="{ path: '/Products'}" append>会議システム</router-link>-->
<!--                  </span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </figcaption>-->
          </figure>
        </router-link>
      </v-col>
    </v-row>
  </div>
  <!--お知らせ-->
  <NewsTable></NewsTable>
   <!--<v-row justify="center" style="margin-top:50px;">
  <v-col cols="12" md="3" lg="3" xl="3" style="padding-left:2rem;">
      <Facebook></Facebook>
  </v-col>
    <v-col cols="12" xs="8" md="8" lg="8" xl="8">
      <serviceSlide></serviceSlide>
    </v-col>
  </v-row>-->
  <HomeTop></HomeTop>
</div>
</template>

<style>
.inline-span {
  display: inline-block;
  margin-right: 1rem;
}
.example-card{
  padding:30px;
  text-align:center;
}
.v-img-text{
  color:white;
  font-size:1.1rem;
}
figure {
  position: relative;
  overflow: hidden;
}
figcaption {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.6);
  -webkit-transition: .3s;
  transition: .3s;
  opacity: 0;
  color: white;
}
figure:hover figcaption {
  opacity: 1;
}

a {
  text-decoration-line: none;
}
iframe {
    width: 100% !important;
}

v-img-text {
    color: white;
    font-size: 1.2rem;
    box-shadow: blue;
    padding-left: 2rem;
}
.figcaption-text{
  font-size: 1rem;
}

.top-box-menu {
  margin-left: 2rem;
}

.top-box-menu a {
  color: #fff!important;
}

.top-box-menu a:hover {
  color: #1976D2!important;
}

.clickable-image {
  cursor: pointer;
}

.top-box-menu a:hover {
    color: #c4c4c4!important;
    border-bottom: 2px solid;
}

.hover-mask {
  position: relative;
  display: inline-block;
  overflow: hidden;
}
.top-box-menu-area .v-responsive__content{
  background: rgba(0,0,0,0.19);
  transition: background 0.3s ease;
}
.top-box-menu-area .v-responsive__content:hover{
  background: rgba(0,0,0,0.53);
}
@media (max-width: 768px) {
    figcaption {
      background: rgba(66, 66, 66, 0.6);
  }
  .top-box-menu {
    margin-top: -1rem;
    padding-right: 1rem;
  }
}

/* スマホではサービスの2列が縦に並んで7行になるので、枠を高くする */
@media (max-width: 599px) {
  .service-box-img {
    height: 250px !important;
  }
}

/* PCではhover、スマホでは常に表示 */
@media (hover: hover) {
  figcaption {
    opacity: 0;
  }

  figure:hover figcaption {
    opacity: 1;
  }
}

@media (hover: none) {
  figcaption {
    opacity: 1 !important;
  }
}
</style>

<script>
// サービスのスライドショー
import serviceSlide from '../components/Home/serviceSlide'
// Facebook
// import Facebook from '../components/Home/Facebook'

// お知らせ
import NewsTable from '../components/Home/NewsTable'

// スライドショー
// import serviceSlide from '../components/Home/serviceSlide'

// トップページコンテンツ
import HomeTop from '../components/Home/HomeTop'

export default {
  name: 'Home',
  components: {
    // serviceSlide,
    // Facebook,
    HomeTop,
    NewsTable,
    serviceSlide
  }
}
</script>
